(() => {
  if (window.location.search.includes('view=ranking')) {
    document.documentElement.classList.add('nini-ranking-view');
    document.title = '人気ランキング – nini shop';
  }

  const pages = document.querySelectorAll('[data-nini-ranking-page]');

  pages.forEach((page) => {
    const tabs = Array.from(page.querySelectorAll('[data-ranking-filter]'));
    const cards = Array.from(page.querySelectorAll('[data-nini-ranking-card]'));
    const emptyMessage = page.querySelector('[data-ranking-empty]');

    const applyFilter = (filter) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const category = card.dataset.rankingCategory || 'all';
        const shouldShow = filter === 'all' || category === filter;

        card.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.rankingFilter || 'all';

        tabs.forEach((item) => {
          item.classList.toggle('is-active', item === tab);
        });

        applyFilter(filter);
      });
    });

    const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    applyFilter(initialTab?.dataset.rankingFilter || 'all');
  });
})();
